import { validateFormSchema } from "@domain/form";
import { Alert, Button, Space } from "antd";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import type { FormField, FormSchema } from "../types";

interface Props {
	fields: FormField[];
	/** Arxivlangan formada nashr yo'q. */
	disabled: boolean;
	isPublishing: boolean;
	onPublish: (schema: FormSchema) => void;
}

/**
 * ⚠️ Validatsiya `@domain/form` ning `validateFormSchema()` idan — server
 * nashr paytida AYNAN shu funksiyani chaqiradi (Task 1). Bu yerdagi
 * tekshiruv **qulaylik**: xatoni maydon yonida ko'rsatadi. Uni
 * serverdagining O'RNIGA qo'yish — himoyani yo'qotish.
 */
export function PublishPanel({ fields, disabled, isPublishing, onPublish }: Props) {
	const { t } = useTranslation("leadForms");
	const [showErrors, setShowErrors] = useState(false);
	const errors = useMemo(() => validateFormSchema({ fields }), [fields]);

	const handleClick = () => {
		if (errors.length > 0) {
			setShowErrors(true);
			return;
		}

		setShowErrors(false);
		onPublish({ fields });
	};

	return (
		<Space direction="vertical" className="w-full">
			{showErrors && errors.length > 0 && (
				<Alert
					data-testid="schema-errors"
					type="error"
					showIcon
					message={t("publish.errorsTitle")}
					description={
						<ul className="m-0 pl-4">
							{errors.map((error, index) => (
								<li
									key={`${error.fieldKey ?? "schema"}-${error.code}-${index}`}
									data-error-code={error.code}
								>
									{error.fieldKey ? `${error.fieldKey}: ` : ""}
									{error.message}
								</li>
							))}
						</ul>
					}
				/>
			)}
			<Button
				data-testid="publish"
				type="primary"
				loading={isPublishing}
				disabled={disabled || fields.length === 0}
				onClick={handleClick}
			>
				{t("publish.submit")}
			</Button>
		</Space>
	);
}
